import React from "react";
import { MessageCircle } from "lucide-react";
import { buildWaLink, WA_TEMPLATES, BAH_WHATSAPP_DISPLAY } from "@/lib/whatsapp";

/**
 * WhatsApp floating action button.
 *
 * Mobile (< md): compact 44×44 circular icon-only control — no label, no
 * phone-number text — to avoid covering hero CTAs / stat cards / forms.
 * Native `title` provides a tooltip; `aria-label` provides the accessible
 * name. Click/action behaviour is unchanged.
 *
 * Desktop (≥ md): full pill with icon + "WhatsApp Technical Team" label.
 */
export default function WhatsAppFAB() {
  const href = buildWaLink(WA_TEMPLATES.technical_general + " ");
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-fab"
      aria-label={`WhatsApp Biodeal Animal Health technical team on ${BAH_WHATSAPP_DISPLAY}`}
      title={`WhatsApp ${BAH_WHATSAPP_DISPLAY}`}
      className="group fixed bottom-5 right-5 z-[100] inline-flex items-center justify-center gap-2 rounded-full bg-[#25D366] text-bah-ink shadow-2xl ring-1 ring-black/10 transition-all hover:bg-[#1FBE5A] hover:-translate-y-0.5 h-12 w-12 md:h-auto md:w-auto md:px-4 md:py-3"
    >
      <span className="relative inline-flex">
        <MessageCircle className="h-5 w-5" strokeWidth={2.5} />
        <span className="absolute inset-0 -m-1 rounded-full bg-[#25D366] opacity-60 animate-pulse-soft" />
      </span>
      <span className="hidden md:inline font-bold text-sm tracking-tight whitespace-nowrap">
        WhatsApp Technical Team
      </span>
    </a>
  );
}
